
// Collect AdditionalCoveragesArray RefIDs from a coverage-requirements result

export const getAdditionalCoverageRefIds = coverageData => {
  const primary = Array.isArray(coverageData) ? coverageData[0] : coverageData
  if (!primary) return []

  return [
    ...new Set(
      (primary.AdditionalCoveragesArray ?? [])
        .map(item => String(item?.ReferenceID ?? item?.ReferenceId ?? ''))
        .filter(Boolean)
    ),
  ]
}

/**
 * Keep multiCollateral items in order, dropping any RefID that already appears
 * in an earlier-kept item's AdditionalCoveragesArray. Mutual links cannot wipe
 * both cards because only already-kept arrays are consulted.
 *
 * @param {Array} items - multiCollateral items (stable order)
 * @param {Record<string, unknown>} coverageByRefId - coverage result per RefID
 * @param {(item: object) => string} getRefId - extracts RefID from an item
 */
export const filterDashboardItemsByAdditionalCoverages = (
  items,
  coverageByRefId,
  getRefId
) => {
  if (!Array.isArray(items) || items.length === 0) return []

  const kept = []
  const coveredByKept = new Set()

  for (const item of items) {
    const refId = getRefId(item)
    if (!refId) continue

    if (coveredByKept.has(refId)) continue

    kept.push(item)

    const additionalRefIds = getAdditionalCoverageRefIds(
      coverageByRefId?.[refId]
    )
    for (const additionalRefId of additionalRefIds) {
      if (additionalRefId !== refId) {
        coveredByKept.add(additionalRefId)
      }
    }
  }

  return kept
}
